// extracted by mini-css-extract-plugin
export default {"cta":"NF-z","disabled":"OF-z"};